// action - state management
import { createSlice } from '@reduxjs/toolkit';
import { UIStore } from 'types/ui-general';

const initialState: UIStore = {
  lastSaved: null,
  breadCrumbs: [],
  gridMode: false,
  portalModal: false,
  showRichText: true,
  currentSlug: '',
  customPageTitle: null,
  mailingListsOpen: false,
  update: null,
  panelStates: {
    detailsCoreFields: true,
    detailsAttire: false,
    detailsSound: false,
    detailsCustomFields: true
  },
  panelStatesById: {},
  detailsView: {
    columnVisibility: {}
  }
};

// ===========================|| DIALOG REDUCER ||=========================== //

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLastSaved(state, action) {
      state.lastSaved = action.payload;
    },
    setBreadcrumbs(state, action) {
      state.breadCrumbs = action.payload;
    },
    setGridMode(state, action) {
      state.gridMode = action.payload;
    },
    setPortalModal(state, action) {
      state.portalModal = action.payload;
    },
    setShowRichText(state, action) {
      state.showRichText = action.payload;
    },
    setCurrentSlug(state, action) {
      state.currentSlug = action.payload;
    },
    setCustomPageTitle(state, action) {
      state.customPageTitle = action.payload;
    },
    setMailingListsOpen(state, action) {
      state.mailingListsOpen = action.payload;
    },
    setUpdate(state, action) {
      state.update = action.payload;
    },
    setPanelState(state, action: { payload: { panel: keyof UIStore['panelStates']; expanded: boolean } }) {
      state.panelStates[action.payload.panel] = action.payload.expanded;
    },
    setPanelStateById(state, action: { payload: { id: string; expanded: boolean } }) {
      state.panelStatesById[action.payload.id] = action.payload.expanded;
    },
    setDetailsColumnVisibility(state, action: { payload: Record<string, boolean> }) {
      state.detailsView.columnVisibility = action.payload;
    }
  }
});

export default ui.reducer;

export const {
  setLastSaved,
  setBreadcrumbs,
  setGridMode,
  setPortalModal,
  setShowRichText,
  setCurrentSlug,
  setCustomPageTitle,
  setMailingListsOpen,
  setUpdate,
  setPanelState,
  setPanelStateById,
  setDetailsColumnVisibility
} = ui.actions;
